import { render, staticRenderFns } from "./AccountsUpdate.vue?vue&type=template&id=a02068fc&"
import script from "./AccountsUpdate.vue?vue&type=script&lang=js&"
export * from "./AccountsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports